export default __webpack_public_path__ + "d04ea0c652e96e098461ace6e7aefc71.jpg";